import { render, staticRenderFns } from "./contact-email.vue?vue&type=template&id=1d24a822"
import script from "./contact-email.vue?vue&type=script&lang=js"
export * from "./contact-email.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports